import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_ORDERS_CHECKOUT_OPTIONS_API,
	GET_ORDERS_CHECKOUT_API,
	POST_ORDERS_CHECKOUT_BY_PEOPLE_API,
	POST_ORDERS_CHECKOUT_CHECK_DEVICE_ORDER_API,
	GET_ORDERS_CHECKOUT_CYCLE_PURCHASE_API,
	POST_ORDERS_CHECKOUT_BY_CYCLE_PURCHASE_API,
	POST_ORDERS_CHECKOUT_CAMPAIGN_API,
} from "@apis/apiPath";
import { useSnackbar } from "notistack";
import useShowLoading from "@util/hook/useShowLoading";
import { isEmpty } from "@util/utils";

const useOrderCheckoutApi = () => {
	const Ajax = useAjax();
	const isLoading = useShowLoading();
	const { enqueueSnackbar } = useSnackbar();

	// 取得結帳需使用到的下拉式選單
	const getOrderCheckoutOptionsApi = useCallback(
		async () => {
			let resp = await Ajax.get(GET_ORDERS_CHECKOUT_OPTIONS_API);
			if (!resp) {
				enqueueSnackbar("讀取資料失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 取得未結帳的會員訂單清單
	const getOrderCheckoutApi = useCallback(
		async id => {
			const resp = await Ajax.get(GET_ORDERS_CHECKOUT_API, { id });
			if (!resp) {
				enqueueSnackbar("讀取資料失敗", { variant: "error" });
			}

			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 取得結帳需使用到的下拉式選單
	// 取得未結帳的會員訂單清單
	const getMemberInfoCardApi = useCallback(
		async id => {
			let params = { id };
			let result = {};
			isLoading(true);
			const orderData = await Ajax.get(GET_ORDERS_CHECKOUT_API, params);
			const resource = await Ajax.get(GET_ORDERS_CHECKOUT_OPTIONS_API);
			if (orderData) result = Object.assign(result, { orderData });
			if (resource) result = Object.assign(result, { resource });
			isLoading(false);
			return result;
		},
		// eslint-disable-next-line
		[],
	);

	const getOrderCheckoutCyclePurchaseApi = useCallback(async params => {
		return await Ajax.get(GET_ORDERS_CHECKOUT_CYCLE_PURCHASE_API, params);
		// eslint-disable-next-line
	}, []);

	// 發送個人結帳資料(包含未結帳及新增訂單項目)
	const postOrderCheckoutByPeopleApi = useCallback(
		async parameters => {
			let resp = await Ajax.post(POST_ORDERS_CHECKOUT_BY_PEOPLE_API, parameters);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") {
				return null; // 排除 0002 錯誤
			}
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	// 新增既存月費同時，檢查是否需要繳智能月費
	const postOrdersCheckoutCheckDeviceOrderApi = useCallback(
		async (memberID, Parameters) => {
			const resp = await Ajax.post(POST_ORDERS_CHECKOUT_CHECK_DEVICE_ORDER_API(memberID), Parameters);
			if (!resp) enqueueSnackbar("讀取資料失敗", { variant: "error" });
			return resp;
		},
		// eslint-disable-next-line
		[],
	);

	const postOrderCheckoutByCyclePurchaseApi = useCallback(async params => {
		return await Ajax.post(POST_ORDERS_CHECKOUT_BY_CYCLE_PURCHASE_API, params);
		// eslint-disable-next-line
	}, []);

	// 取得訂單抵用卷折扣資料
	const postOrdersCheckoutCampaignApi = useCallback(async params => {
		return await Ajax.post(POST_ORDERS_CHECKOUT_CAMPAIGN_API, params);
		// eslint-disable-next-line
	}, []);

	return {
		getOrderCheckoutOptionsApi,
		getOrderCheckoutApi,
		getMemberInfoCardApi,
		getOrderCheckoutCyclePurchaseApi,
		postOrderCheckoutByPeopleApi,
		postOrdersCheckoutCheckDeviceOrderApi,
		postOrderCheckoutByCyclePurchaseApi,
		postOrdersCheckoutCampaignApi,
	};
};

export default useOrderCheckoutApi;
